import { render, staticRenderFns } from "./ContactHeaderVertical.vue?vue&type=template&id=4fbed170&scoped=true"
import script from "./ContactHeaderVertical.vue?vue&type=script&lang=js"
export * from "./ContactHeaderVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbed170",
  null
  
)

export default component.exports